module.exports = __webpack_public_path__ + "img/赋能大使.2036c15e.jpg";